export enum SearchQueryKey {
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  NUMBER_OF_PEOPLE = 'numberOfPeople',
  FLEX_SEARCH = 'flexDates',
  BUSINESS_MODEL = 'businessModel',
  TIMEZONE = 'tz',
}
